/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import {
  Polymer,
  html
} from '@polymer/polymer/polymer-legacy.js';
import './bill-component.js';
import './bill-transaction-history.js';
import '../../speedboat_ui/elements/app-slide-in-out-transition.js';
/* import '../../image-mask/image-mask.js'; */
const template = html`
		<style include="app-styles mdl-grid-css bills-shared-styles">
        .menu-position
		{
          position: absolute;
          right: 4px;
          top: 62px;
		} 
		:dir(rtl) .menu-position
		{
          position: absolute;
          left: 4px;
          top: 62px;
		  right: auto;
		} 
		.success-icon {
				--iron-icon-fill-color: var(--success-label-color);
				--iron-icon-width: 24px;
				--iron-icon-height: 24px;
		}
		
		.menu-horizontal{
			    height: 105px;
                background-color:var(--primary-light-color);
				top:0;
				left:0;
				width: 100% !important;
		}
		:dir(rtl) .menu-horizontal{
			    height: 105px;
                background-color:var(--primary-light-color);
				position: absolute;
				top:0;
				right:0;
				left: auto;
				width: 100% !important;
		}

		:dir(rtl) .more-menu{
            right:auto;
        }
		.close-btn-color
			{
             color:var(--secondary-dark-color);
			 z-index: 2;
			}
		.margin-dynamic[tablet],.margin-dynamic[desktop]
		{
			margin:8px;
	    }
	    .outlineOffset:focus{
	      outline:2px solid var(--DDA-outline-color);
	    }
      .screen-height[phone]{
        min-height: calc(100vh - 56px);
      }
      .biller-static{
        position:static
      }
		</style>
    <!-- Get Billers List -->
    <slide-in-out-transition animate-right={{animateRight}} animate-left={{animateLeft}}   swiped-left={{swipedLeft}}>
    <oe-ajax id="billerListFetch" url="/api/CBUsers/{{userId}}/billers" last-response="{{billerListing}}" on-response="setBillerActiveFlag"
            on-error="showError" auto></oe-ajax>
		<page-title name="{{pageName}}" paper-toolbar-back-color="var(--primary-light-color)" paper-toolbar-text-color="var(--primary-dark-color)" left-action="{{leftAction}}" right-action="{{rightAction}}"></page-title>
        <app-media-query desktop="{{desktop}}" phone="{{phone}}" tablet="{{tablet}}"></app-media-query>
		<neon-animated-pages class="light-background screen-height" phone$="{{phone}}" selected="{{selectedPage}}" attr-for-selected="pagetitle" entry-animation="slide-from-bottom-animation">
			<neon-animatable pagetitle="h_BillerDetails" class="biller-static">
				<div id="biller-bill" class="page-container">
			<template is="dom-if" if="{{registrationId}}">
				
				<div  class="component-header-outer-container padding-b-zero mdl-grid light-background shadow">
							<div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--4-col-tablet  mdl-cell--4-col-desktop mdl-cell--4-offset-desktop mdl-cell--2-offset-tablet">
						<div class$="header-outer-container position-relative {{_getHeaderColor(billerDetails.category.codeDescription)}}" id="header-outer">
						<div class="boxHeader padding-r-zero">
            <template is="dom-if" if="{{!showMoreOptions}}">
                <span aria-labelledby="hiddenInformation">
                  <div id="hiddenInformation" class="display-none">
                  <oe-i18n-msg msgid="m_navigationmoreoption"></oe-i18n-msg></div>   
                </span>

							<biller-header biller-details="{{billerDetails}}" biller-active-flag={{billerActiveFlag}} biller-active-flag-show=true biller-reg="{{registrationId}}"></biller-header>
              <iron-icon id="MoreMenu" on-tap="_openHeaderMenu" on-keydown="_openHeaderDDAMenu" class="outlineOffset more-menu" name="MoreMenu" icon="icons:more-vert" tabindex="0" aria-label$="biller {{getLabel('b_moreActions')}}" role="button"></iron-icon>
            </template>
            <template is="dom-if" if="{{showMoreOptions}}">
              <div id="header-menu" role="dialog" class$="margin-zero menu-horizontal border-round-8px padding-r-zero mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--2-offset-tablet mdl-cell--6-col-desktop mdl-cell--3-offset-desktop {{_getMenuBorderColor(billerDetails.category.codeDescription)}}">
                <paper-icon-button on-tap="_closeHeaderMenu" id="closeBtn" on-keydown="focusMore" class="outlineOffset close-btn-color position-absolute-t-r" icon="close" aria-label$="{{getLabel('b_Close')}}"></paper-icon-button>
                <div class="mdl-grid padding-b-zero"> 
                  <paper-button id="btnEdit" class="outlineOffset content-align-horizontal-start text-brand-color" on-tap="editBiller">
                    <oe-i18n-msg class="text-brand-color" msgid="b_Edit"></oe-i18n-msg>
                  </paper-button>
                </div>
                <div class="mdl-grid padding-b-zero padding-t-zero">
                  <template is="dom-if" if="{{!billerActiveFlag}}">
                    <paper-button class="outlineOffset padding-t-zero content-align-horizontal-start text-brand-color" on-tap="activateDeactivateBiller" on-keydown="closeDialog">
                        <oe-i18n-msg class="text-brand-color" msgid="b_Activate"></oe-i18n-msg>
                    </paper-button>
                  </template>
                  <template is="dom-if" if="{{billerActiveFlag}}">
                    <paper-button class="outlineOffset padding-t-zero content-align-horizontal-start text-brand-color" on-tap="activateDeactivateBiller" on-keydown="closeDialog">
                        <oe-i18n-msg class="text-brand-color" msgid="b_Deactivate"></oe-i18n-msg>
                    </paper-button>
                  </template>
                </div>
              </div>
            </template>
						    </div>
						</div>
					</div>
                    

							<div role="section" class="mdl-cell margin-t-zero mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--2-offset-tablet mdl-cell--4-col-desktop  mdl-cell--4-offset-desktop">
                <biller-additional-details hidden="true"  biller-details="{{billerDetails}}" biller-reg="{{registrationId}}" transact-details="{{billHistory}}"></biller-additional-details>
								<!-- In case autopay is enabled for a biller -->
								<template is="dom-if" if="{{billerDetails}}">
									<template is="dom-if" if="{{isAutoPay(billerDetails.autoPayDetails)}}">
										<div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop background-secondary border-round-8px secondary-dark-text-s">
											<iron-icon id="success-tick" class="success-icon" name="SucessIcon" icon="icons:check"></iron-icon>
											<template is="dom-if" if="{{isLimitAmount(billerDetails.autoPayDetails)}}">
												<oe-i18n-msg msgid="l_AutopayEnabledFor"></oe-i18n-msg>
												{{symbolizeCurrency(billerDetails.autoPayDetails.limitAmount.currency,billerDetails.autoPayDetails.limitAmount.amount)}}
											</template>
											<template is="dom-if" if="{{isFullAmount(billerDetails.autoPayDetails)}}">
												<oe-i18n-msg msgid="l_AutopayFullBillAmount"></oe-i18n-msg>
											</template>
											<template is="dom-if" if="{{isMinimumAmount(billerDetails.autoPayDetails)}}">
												<oe-i18n-msg msgid="l_AutopayMinimumBillAmount"></oe-i18n-msg>
											</template>
										</div>
									</template>
								</template>
					</div>
				</div>
				
			</template>

			<template is="dom-if" if="{{billId}}">
						<div class="component-header-outer-container light-background mdl-grid padding-zero shadow">
				<div class="background-primary full-width margin-dynamic" desktop$="{{desktop}}" tablet$="{{tablet}}">
								<div class="mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--2-offset-tablet mdl-cell--4-offset-desktop mdl-cell--4-col-desktop position-relative">
									<bill-component bill-details="{{billDetails}}" bill-type-info="{{billTypeInfo}}" parsed-bill="{{parsedBill}}" bill-id="{{billId}}" bill-type="{{upcomingBillType}}" registration-id="{{registrationId}}"
									    transaction-history="{{transactionHistory}}" biller-details="{{billerDetails}}"></bill-component>
					   
					</div>
					
				</div>


				
				</div>
					</template>
					<template is="dom-if" if="{{billerDetails}}">
				<div id="trnx-hist" class="shadow padding-t-zero padding-b-zero light-background full-width">
							<div class="full-width mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop margin-b-zero">
							<bill-transaction-history registration-id="{{registrationId}}" biller-details="{{billerDetails}}" transact-details="{{billHistory}}" last-transact="{{transactionHistory}}"></bill-transaction-history>
			   </div>
				</div>
			</template>
					<div class="mdl-grid light-background shadow padding-t-zero">
					<div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop text-align-right">
						<template is="dom-if" if="{{checkTransactDetails(billHistory)}}">
							<div on-tap="_showTransactionPage" tabindex="0" class="outlineOffset">
									<oe-i18n-msg class="font-size-m text-brand-color" msgid="b_ViewAll"></oe-i18n-msg>
							</div>
						</template>
		</div>
					</div>
				</div>

			</neon-animatable>
			<neon-animatable id="transaction-details" pagetitle="h_PreviousTransactions" class="biller-static">
      <div class="mdl-grid padding-b-zero mdl-cell--hide-desktop background-secondary mdl-cell--hide-tablet"></div>
				<bill-transaction-history transact-details="{{billHistory}}"></bill-transaction-history>
			</neon-animatable>
    </neon-animated-pages>
    <!-- To open a authentication modal in which user need to enter transaction password -->
   <app-dialog name="h_Authorization" id="billeractivateAuthorization" elementid="billeractivateAuthorization">
      <div class="">
          <div class="margin-b-zero padding-b-zero mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-grid text-align-left">
              <fin-auth-element-wrapper id="billerActAuth" class="full-width" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
          </div>
          <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
              <paper-button id="activate_Authsubmit2" on-tap="activateDeactivateBillerProceed" class="outlineOffset flat-button">
                  <oe-i18n-msg id="actdeactSubmitButton" class="text-brand-color" msgid="b_Submit"></oe-i18n-msg>
              </paper-button>
          </div>
      </div>
    </app-dialog>
    </slide-in-out-transition>`;
Polymer({
  is: "biller-details-new",
  _template: template,
  behaviors: [sbBehaviours.billCommonFunctions, accessibilityBehaviours.commonFunctions, sbBehaviours.authAndSubmit],
  properties: {
    registrationId: {
      type: String,
      notify: true
    },
    billerDetails: {
      type: Object,
      notify: true
    },
    billDetails: {
      type: Object,
      notify: true
    },
    billHistory: {
      type: Array,
      notify: true
    },
    upcomingBillType: {
      type: String,
      notify: true
    },
    transactionHistory: {
      type: Array,
      notify: true
    },
    parsedBill: {
      type: Object,
      notify: true
    },
    //list of billers
    billerListing: {
      type: Array,
      notify: true
    },
    //To check if biller is active or not
    billerActiveFlag: {
      type: Boolean,
      notify: true
    },
    //to set auth methods
    authMethods: {
      type: Array,
      notify: true
    },
    //to set the endpoint url for activate/deactivate biller
    actDeactBillerUrl: {
      type: String
    },
    //left action in page title
    leftAction: {
      type: Object,
      notify: true
    },
    //Biller activate/deactivate success object
    actDeactSuccessObject: {
      type: Object,
      notify: true
    },
    showMoreOptions: {
      type: Boolean,
      value: false
    },
    billTypeInfo: {
      type: String,
      notify: true,
      observer: '_billTypeInfo'
    },
    swipedLeft: {
      type: Boolean,
      notify: true,
      observer: '_swipedLeftInvoked'
    }
  },
  isLimitAmount: function (autoPay) {
    return autoPay.autoPayMode.cmCode == 'L' ? true : false;
  },
  isFullAmount: function (autoPay) {
    return autoPay.autoPayMode.cmCode == 'F' ? true : false;
  },
  isMinimumAmount: function (autoPay) {
    return autoPay.autoPayMode.cmCode == 'M' ? true : false;
  },
  attached: function () {
    if (window.navigate_from.page == 'billPayment-new') {
      this.billDetails = window.setParams.billDetails;
    }
    this.animateRight = !this.animateRight;
    this.userId = clientStorage.get(storageType.session, 'userId');
    setTimeout(this._gotoBillerDetails.bind(this), window.timeConstants.pageAnimate);
  },
  _swipedLeftInvoked() {
    this._animateToBills().bind(this);
  },
  _animateToBills: function () {
    this.animateLeft = !this.animateLeft;
    setTimeout(this._gotoBillerList, window.timeConstants.pageAnimate);
  },
  _gotoBillerList: function () {
    window.oe_navigate_to("/biller-landing-new", undefined);
  },
  _gotoBillerDetails: function () {
    this.pageName = 'h_BillerDetails';
    this.$$('#biller-bill').hidden = false;
    this.selectedPage = 'h_BillerDetails';
    this.leftAction = {
      leftIcon: 'arrow-back',
      leftCallback: this._animateToBills.bind(this) //hard binding to ensure 'this' object binding
    };
  },
  checkTransactDetails: function () {
    if (this.billHistory.length > 3 && this.phone) {
      return true;
    }
    return false;
  },
  _showTransactionPage: function () {
    this.$$('#biller-bill').hidden = true;
    this.pageName = 'h_PreviousTransactions';
    this.leftAction = {
      leftIcon: 'arrow-back',
      leftCallback: this._gotoBillerDetails.bind(this) //hard binding to ensure 'this' object binding
    };
    this.selectedPage = 'h_PreviousTransactions';
  },
  symbolizeCurrency: function (curr, amount) {
    return currency.symbolize(curr + " " + amount);
  },
  _openHeaderMenu: function () {
    this.showMoreOptions = true;
    var id = "#header-outer";
    this.$$(id).classList.remove('header-outer-container');
    setTimeout(function () {
      this.$$("#closeBtn").focus();
    }.bind(this), 500);
  },
  _openHeaderDDAMenu: function (e) {
    if (e.keyCode == 13) {
      this._openHeaderMenu(e);
    }
  },
  focusMore: function (e) {
    if (e.keyCode == 13) {
      this._closeHeaderMenu(e);
    } else if (e.shiftKey && e.keyCode == 9) {
      this.showMoreOptions = false;
    }
  },
  _closeHeaderMenu: function () {
    this.showMoreOptions = false;
    var id = "#header-outer";
    this.$$(id).classList.add('header-outer-container');
    setTimeout(function () {
      this.$$("#MoreMenu").focus();
    }.bind(this), 500);
  },
  isAutoPay: function (autoPay) {
    if (autoPay.autoPayRequired.cmCode == 'Y')
      return true;
    return false;
  },
  editBiller: function () {

    window.oe_navigate_to("edit-biller-details", {
      "registrationId": this.registrationId,
      "billerRegistrationId": this.registrationId,
      "subscriptionDetails": "",
      "billerDetails": this.billerDetails,
      "billerNickname": this.billerDetails.billerNickname,
      "autoPayToggle": this.billerDetails.autoPayDetails.autoPayRequired.cmCode == "Y" ? true : false,
      "stdCategoryPageName": getLabel("l_edit") + " " + getLabel("h_Biller"),
      "autoPayMode": this.billerDetails.autoPayDetails.autoPayMode.cmCode ? this.billerDetails.autoPayDetails.autoPayMode.cmCode : "",
      "limitAmount": this.billerDetails.autoPayDetails.limitAmount.amount,
      "routePageName": "/bills"
    });
  },
  showError: function (event) {
    if (event && event.detail && event.detail.error && event.detail.error.message) {
      this.fire('oe-show-error', event.detail.error.message);
    }
  },
  //setting the biller active flag and the url
  setBillerActiveFlag: function () {
    var self = this;
    var billertemplist = this.billerListing.filter(function (item) {
      if (item.registrationId == self.registrationId) return item.billerActiveFlg;
    });

    if (billertemplist[0].billerActiveFlg === "Y") {
      this.billerActiveFlag = true;
      this.actDeactBillerUrl = "/api/RetailBillers/" + this.registrationId + "/" + "deactivation";
    }

    if (billertemplist[0].billerActiveFlg === "N") {
      this.billerActiveFlag = false;
      this.actDeactBillerUrl = "/api/RetailBillers/" + this.registrationId + "/" + "activation";
    }
  },
  //onclick of activate or deactivate the biller
  activateDeactivateBiller: function () {
    if ((this.authMethods == undefined || this.authMethods) && this.authMethods.length == 0) {
      this.authMethods = [];
      this.header = {};
    }
    var self = this;
    var ajaxCall = document.createElement("oe-ajax");
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = this.actDeactBillerUrl;
    ajaxCall.method = "put";
    ajaxCall.body = {};
    oeAjaxEventListner(ajaxCall);
    self.submitDetails(ajaxCall.url, ajaxCall.method, ajaxCall.body, self.header);
  },
  closeDialog: function (e) {
    if (e.keyCode == 9) {
      this.showMoreOptions = false;
    }
  },


  //activate/deactivate DDA
  activateDeactivateBillerDDA: function (e) {
    if (e.keyCode === 13 || KeyboardEvent.charCode == 13 || KeyboardEvent.keyCode == 13 || e.which == 13) {
      this.activateDeactivateBiller();
    }
  },
  //To reset the header values for the auth methods
  activateDeactivateBillerProceed: function () {
    if (this.authenticationValidation(this.authMethods)) return;
    if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

    if (this.authMethods && this.authMethods.length == 2) {
      this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
      this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
    }

    this.submitDetails(this.actDeactBillerUrl, "PUT", {}, this.header);
  },
  //Proceed DDA
  activateDeactivateBillerProceedDDA: function (e) {
    if (e.keyCode === 13 || KeyboardEvent.charCode == 13 || KeyboardEvent.keyCode == 13 || e.which == 13) {
      this.activateDeactivateBillerProceed();
    }
  },
  //To open autorization modal success page for activate deactivate biller
  _callAuthPage: function () {
    this.$.billeractivateAuthorization.$$("#billeractivateAuthorization").open();
  },
  //closes the authorization modal once transaction password is entered and submit button is clicked and re-routes to the success page
  _callSucessPage: function (event) {
    this.$.billeractivateAuthorization.$$("#billeractivateAuthorization").close();
    if (event.detail.__data.xhr.status === 200) {
      var successHeaderArrayString;
      var succesArray = event.detail.__data.xhr.getAllResponseHeaders().split('\r\n');
      for (let i = 0; i < succesArray.length; i++) {
        if (succesArray[i].includes("channelcontext")) {
          successHeaderArrayString = succesArray[i].split(/:(.+)/)[1];
        }
      }
      var successHeaderArrayObj = JSON.parse(successHeaderArrayString);
      var successMsg = successHeaderArrayObj.status.message[0].messageDesc.split('.')[0] + '.';
      var referenceId = successHeaderArrayObj.status.message[0].messageAddlnInfo.split('=')[1];
      this.actDeactSuccessObject = {
        "billerName": this.billerDetails.billerName,
        "successMsg": successMsg,
        "referenceId": referenceId,
        "billerActiveStatus": this.billerActiveFlag ? getLabel('l_No') : getLabel('l_Yes')
      }
      this.pageName = "";
      this.leftAction = [];
      this.rightAction = {};
      window.oe_navigate_to('/biller-activate-deactivate-success', {
        "page-title": "",
        "billerDetails": this.billerDetails,
        "actDeactSuccessObject": this.actDeactSuccessObject
      });
    }
  }
});
